/**
 * SLO aspect control — the inspector editor half of the telemetry SLO pack
 * (the engine half is `@archlang/engine`'s `sloLanguagePack`). Edits `slo.*`
 * (and its `observed.*` measurement peer) as a numeric millisecond field
 * instead of a raw string, committing through the normal aspect set path.
 */
import { useState } from "react";
import type { AspectControlProps } from "./aspectControlRegistry.js";

export function SloAspectControl({ path, value, onCommit }: AspectControlProps): React.ReactElement {
  const [draft, setDraft] = useState(value);
  const commit = (): void => {
    const next = draft.trim();
    if (next && next !== value) onCommit(next);
  };
  return (
    <input
      type="number"
      inputMode="numeric"
      aria-label={`${path} (ms)`}
      className="bg-transparent border border-transparent rounded-sm px-1 flex-1 text-slate-300 tabular-nums focus:border-slate-600 focus:bg-slate-800/(--tint-dim) focus:outline-hidden"
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onKeyDown={(e) => e.key === "Enter" && commit()}
      onBlur={commit}
    />
  );
}
